import { Movement } from './../../../../models/loyalty-movement.model';
import { KontableComponent } from './../../../../modules/UIKit/components/kontable/kontable.component';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-loyalty-account-balance-table-mg',
  templateUrl: './loyalty-account-balance-table-mg.component.html',
  styleUrls: ['./loyalty-account-balance-table-mg.component.css']
})
export class LoyaltyAccountBalanceTableMgComponent implements OnInit {
  paginationType = KontableComponent.ServerPagination;
  noFilter = KontableComponent.NoFilter;
  dateFilter = KontableComponent.DateFilter;
  @Input() actualBalance: number;
  @Input() movements: Movement[];

  constructor() { }

  ngOnInit() { }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-account-balance/loyalty-account-balance-table-mg/loyalty-account-balance-table-mg.component.ts